import axios from 'axios'
import { castAttributesForCamelCase } from '../../../modules/string_converter'
import { formatQsca } from '../../../modules/analysis'
import cloneDeep from 'lodash.clonedeep'

export const companiesAnalysisQsca = {
  namespaced: true,
  state: {
    loading: false,
    qscas: [],
    storeReviews: [],
    competitorReviews: [],
    competitorMode: false,
    providedAiReviewSentencesAnalysis: false,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    changeCompetitorMode(state, bool) {
      state.competitorMode = bool
    },
    changeProvidedAiReviewSentencesAnalysis(state, bool) {
      state.providedAiReviewSentencesAnalysis = bool
    },
    readAnalysisQscaSuccess(state, payload) {
      state.storeReviews = payload.data.reviews.store.map(v => castAttributesForCamelCase(v))
      state.competitorReviews = payload.data.reviews.competitor ? payload.data.reviews.competitor.map(v => castAttributesForCamelCase(v)) : []
      state.qscas = payload.data.qsca.map(v => {
        let data = castAttributesForCamelCase(v)
        data = formatQsca(data)
        return data
      })

      // TODO: バックエンドに competitor.storeNamesをcompetitorNames してこのコードを消したい
      if (state.competitorMode) {
        state.qscas = state.qscas.map((v) => {
          v.competitorData = v.competitorData?.map(competitor => {
            competitor.competitorNames = competitor.stores.map(store => store.name)
            return formatQsca(competitor)
          })
          v.competitorGraphData = cloneDeep(v.competitorData)
          return v
        })
      }
      state.loading = false
    },
  },
  actions: {
    changeCompetitorMode({ commit }, bool) {
      commit('changeCompetitorMode', bool)
    },
    changeProvidedAiReviewSentencesAnalysis({ commit }, bool) {
      commit('changeProvidedAiReviewSentencesAnalysis', bool)
    },
    readAnalysisQsca({ commit, rootState }, query) {
      commit('apiConnect')

      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/analysis/qsca' + '.json', {
          params: query
        })
        .then(res => {
          commit('readAnalysisQscaSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
  }
}
